export enum AttachmentsSortProperty {
  Amount = 'amount',
  CreatedTime = 'createdTime',
  DocumentDate = 'documentDate',
  Supplier = 'supplier',
}
